import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ListView from '../Common/ListView.react';
import ListItem from './VenueListItem';
import LocationIcon from 'material-ui/svg-icons/device/location-searching';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';

import buildContextMenu from '../Common/BuildContextMenu';

class VenueList extends Component {

    constructor (props) {
        super(props);
        this.state = {
            venues: [],
            count: 0,
            page: 0,
            limit: 50,
            actions: [],
            sortCriteria: null,
            sortMapCriteria: null
        };
        this.onChange = this.onChange.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentDidMount() {
        VenueStore.addChangeListener(this.onChange);
        VenueActions.getAll();
        this.setState({actions: buildContextMenu(this.getActions(), this.context.auth)});
    }

    componentWillUnmount() {
        VenueStore.removeChangeListener(this.onChange);
    }

    getActions() {
        return [
            {
                link: '/dashboard/locations',
                icon: <LocationIcon />,
                label: 'Locations',
            },
            { type: 'divider' },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }

    render() {

        return (
            <ListView
                title="Venues"
                sortOptions={this.props.sortOptions}
                sortAction={this.sort}
                searchAction={VenueActions.search}
                actions={this.state.actions}
                items={this.state.venues}
                itemDecorator={ListItem}
                newEntityUrl={this.context.auth.isAdmin() ? '/dashboard/venue/new' : ''}
            />
        )
    }

    onChange() {
        const venues = VenueStore.getAll();
        if (!!venues) {
            if (venues.length <= 1 || !this.state.sortCriteria || !this.state.sortMapCriteria) {
                this.setState({venues});
            } else {
                const mapped = venues.map(this.state.sortMapCriteria);
                mapped.sort(this.state.sortCriteria);
                const sortedVenues = mapped.map((el) => venues[el.index]);
                this.setState({venues: sortedVenues});
            }
        }
    }

    sort(options) {
        let sortCriteria, sortMapCriteria;
        switch (options.sort) {
            case 'name':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.name});
                break;
            case 'status':
                sortCriteria = (a, b) => a.value.localeCompare(b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el.status});
                break;
            case 'id':
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: Number(el.id)});
                break;
            default:
                sortCriteria = (a, b) => (a.value - b.value);
                sortMapCriteria = (el, i) => ({index: i, value: el[this.state.sort]});
        }
        this.setState({sort: options.sort, sortCriteria, sortMapCriteria});
        VenueActions.getAll({sort: options.sort});
    }

}

VenueList.defaultProps = {
    sortOptions: [
        {label: "Name", value: 'name'},
        {label: "Status", value: 'status'},
        {label: "Created", value: 'id'}
    ]
};

VenueList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default VenueList;
